import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';
import { getMockClaimDetails, isMockModeEnabled } from '../utils/mockDataHelper';
import { getUnformattedClaimNumber } from '../utils/Utilities';

export async function getClaimDetails(
  claimNumber: string,
  urlKey: string,
  sessionId: string,
  custKey: string,
  claimsSystem?: string
) {
  // If in mock mode, return mock claim details
  if (isMockModeEnabled()) {
    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    return await getMockClaimDetails(claimNumber);
  }

  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    let URI = `${process.env['NX_DCV2_API_BASE_URL']}claim-detail/${getUnformattedClaimNumber(claimNumber)}`;

    // Add claimsSystem query parameter for Workers Comp claims
    if (claimsSystem) {
      URI += `?claimsSystem=${claimsSystem}`;
    }

    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });
    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;
    const responseCollection = _get(responseData, 'response', []);

    if (_get(responseCollection[0], 'Status.code', '') === '200') {
      return responseData;
    } else {
      return { error, statusCode, message };
    }
  } catch (error) {
    console.log('getClaimDetails:error', error);
    return error;
  }
}
